import { FC, useCallback, useState } from "react"
import DeleteItemDialog from "src/components/shared/DeleteItemDialog"
import { IIncomeCategory } from "src/domain/entities"
import { incomeCategoryDeleteService } from "src/domain/services/incomeCategory/incomeCategoryDeleteService"
import { useAuth } from "src/hooks"
import { getErrorMessage } from "src/utils/helpers"

interface Props {
	incomeCategory: IIncomeCategory
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const IncomeCategoryDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	incomeCategory,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleIncomeCategoryDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await incomeCategoryDeleteService({ id: incomeCategory.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [incomeCategory, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete IncomeCategory: ${incomeCategory.name}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleIncomeCategoryDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
